import { HiOutlineCake, HiOutlineHomeModern } from "react-icons/hi2";
import { AutomatedGiftTab } from "../../features/automatedGifts/automatedGiftsApi";

export const AUTOMATED_GIFTS_TABS: {
  id: AutomatedGiftTab;
  label: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  emptyCta: string;
}[] = [
  {
    id: "birthday",
    label: "Birthday",
    icon: <HiOutlineCake />,
    title: "Birthday gifts on autopilot",
    description:
      "When recipients share their birthday in chat, they're added here automatically. We'll remind you to send a gift each year.",
    emptyCta: "Set up birthday gifting",
  },
  {
    id: "home-anniversary",
    label: "Home Anniversary",
    icon: <HiOutlineHomeModern />,
    title: "Home anniversary gifts",
    description:
      "When a home-occasion gift is redeemed, that recipient is added here so you can celebrate their home anniversary every year.",
    emptyCta: "Set up home anniversary gifting",
  },
];

export function parseAutomatedGiftTab(value: string | null): AutomatedGiftTab {
  if (value === "home-anniversary") {
    return "home-anniversary";
  }
  return "birthday";
}
